/* =====================================================================
   Millî (resmî) tatiller — yıldan bağımsız sabit {ay, gün} kuralları.
   Kanun yolu süresi hesabında son günün ilk iş gününe taşınması için
   kullanılır (CMK m.39/4). Dinî bayramlardan ayrı tutulur: bunlar kanunla
   sabittir, kullanıcı tarafından düzenlenmez (UI'si yoktur).
   ===================================================================== */

export const MILLI_TATILLER = [
  { ay: 1, gun: 1, ad: 'Yılbaşı' },
  { ay: 4, gun: 23, ad: 'Ulusal Egemenlik ve Çocuk Bayramı' },
  { ay: 5, gun: 1, ad: 'Emek ve Dayanışma Günü' },
  { ay: 5, gun: 19, ad: "Atatürk'ü Anma, Gençlik ve Spor Bayramı" },
  { ay: 7, gun: 15, ad: 'Demokrasi ve Millî Birlik Günü' },
  { ay: 8, gun: 30, ad: 'Zafer Bayramı' },
  { ay: 10, gun: 29, ad: 'Cumhuriyet Bayramı' },
];

/**
 * Verilen tarih sabit bir millî tatile denk geliyorsa adını, değilse null döner.
 * iso: 'YYYY-MM-DD'. Date kurmadan ay/gün karşılaştırması yapar (timezone-güvenli).
 */
export function milliTatilSebebi(iso) {
  if (typeof iso !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  const ay = Number(m[2]);
  const gun = Number(m[3]);
  const t = MILLI_TATILLER.find((x) => x.ay === ay && x.gun === gun);
  return t ? t.ad : null;
}
